import { render, staticRenderFns } from "./detailsCommande.vue?vue&type=template&id=ac794f08&"
import script from "./detailsCommande.vue?vue&type=script&lang=js&"
export * from "./detailsCommande.vue?vue&type=script&lang=js&"
import style0 from "./detailsCommande.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports